module.exports = __webpack_public_path__ + "img/img26.fcd9fe51.svg";